<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.productPlan.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.productPlan.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.productPlan.delete')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.productPlan.searchPh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.productPlan.search')}}</el-button>
                </div>
            </div>

            <el-table :data="productplans" border class="table" ref="multipleTable" :element-loading-text="$t('pages.productPlan.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected" :height="tableHeight">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.productPlan.index')"></el-table-column>
                <el-table-column sortable prop="name" :label="$t('pages.productPlan.name')"></el-table-column>
                <el-table-column sortable prop="pYear" :label="$t('pages.productPlan.yearProd') + '(kt)'" width="150"></el-table-column>
                <el-table-column sortable prop="pMonth" :label="$t('pages.productPlan.monthProd') + '(t)'" width="150"></el-table-column>
                <el-table-column sortable prop="pDay" :label="$t('pages.productPlan.dayProd') + '(t)'" width="150"></el-table-column>
                <el-table-column sortable prop="pHour" :label="$t('pages.productPlan.hourProd') + '(t)'" width="150"></el-table-column>
                <!-- <el-table-column prop="balanceNames" label="设备"></el-table-column> -->
                <!-- <el-table-column prop="content" label="设备">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top-start" title="详情">
                            <p>{{ scope.row.balanceNames }}</p>
                            <div slot="reference" class="name-wrapper">{{ scope.row.balanceNames | ContentFormat }}</div>
                        </el-popover>
                    </template>
                </el-table-column>-->
                <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
                <el-table-column prop="enabled" :label="$t('pages.productPlan.enabled')" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="logTypeColor(scope.row.enabled)" disable-transitions>{{ logTypeFormatMethod(scope.row.enabled) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="modifyDate" :label="$t('pages.productPlan.modifyTime')" width="140">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.productPlan.operation')" width="110" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.productPlan.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="40%" :close-on-click-modal="false">
            <el-form ref="productplan" :model="productplan" :rules="rules" label-width="110px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.name')" prop="name">
                            <el-input v-model="productplan.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.enabled')" prop="enabled">
                            <el-switch v-model="productplan.enabled"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.yearPlan')" prop="pYear">
                            <el-input v-model="productplan.pYear" oninput="value=value.replace(/[^0-9.]/g,'')" @change="clset"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.monthPlan')" prop="pMonth">
                            <el-input v-model="productplan.pMonth" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.dayPlan')" prop="pDay">
                            <el-input v-model="productplan.pDay" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.productPlan.hourPlan')" prop="pHour">
                            <el-input v-model="productplan.pHour" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.productPlan.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('productplan')">{{$t('pages.productPlan.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { SortField } from '../../utils/helper';
let that;
export default {
    name: 'productplan',
    data: function () {
        return {
            isIndeterminate: true,

            tableHeight: window.innerHeight * 0.6,
            headTitle: '',
            viewVisible: false,
            isadd: false,
            productplan: {
                pMonth: '',
                pDay: '',
                pHour: '',
                pYear: '',
                name: '',
                enabled: '0'
            },
            balanceArr: [],
            UserArr: [],
            balanceArrGroup: [],
            editVisible: false,
            productplans: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                PageIndex: 1,
                PageSize: 15
            },
            FrequencyArr: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t('pages.productPlan.valid.nameRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        ContentFormat(content) {
            if (content.length >= 60) {
                content = content.substr(0, 60) + '...';
            }
            return content;
        }
    },
    created() {
        this.getData();
    },
    methods: {
        logTypeFormatMethod(Type) {
            return Type == '1' ? this.$t('pages.productPlan.enabledTagOn') : this.$t('pages.productPlan.enabledTagOff');
        },
        saveEdit() {
            this.$refs['productplan'].validate((valid) => {
                if (valid) {
                    this.productplan.enabled = this.productplan.enabled ? '1' : '0';
                    if (this.isadd) {
                        this.$zybhttp
                            .post('productplan/productplanAdd', this.productplan)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.productPlan.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.productplan = {};
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.productPlan.addError')));
                    } else {
                        this.$zybhttp
                            .post('productplan/productplanUpdate', this.productplan)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.productPlan.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.productPlan.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.productPlan.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        logTypeColor(Type) {
            var Name = '';
            if (Type == '0') {
                Name = 'danger';
            } else if (Type == '1') {
                Name = 'success';
            } else {
                Name = 'brand';
            }
            return Name;
        },
        clset(val) {
            var year = parseInt(val);
            var day = parseInt((year * 1000) / 330);
            var month = parseInt((year * 1000) / Math.round(330 * 12 / 365));
            var hour = parseInt(day / 16);
            this.productplan.pYear = year;
            this.productplan.pDay = day ;
            this.productplan.pMonth = month ;
            this.productplan.pHour = hour ;
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('productplan/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.productplans = newdata;
                        console.log(newdata);
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.productPlan.fetchError')));
        },
        handleEdit(id, row) {
            this.productplan = JSON.parse(JSON.stringify(row)); // row;
            this.productplan.id = id;
            this.productplan.enabled = this.productplan.enabled == '1' ? true : false;
            this.editVisible = true;
            this.isadd = false;
            this.headTitle = this.$t('pages.productPlan.editTitle');
        },
        dbSelected(row) {
            this.productplan = JSON.parse(JSON.stringify(row));
            this.productplan.id = row.id;
            this.productplan.enabled = this.productplan.enabled == '1' ? true : false;
            this.editVisible = true;
            this.isadd = false;
            this.headTitle = this.$t('pages.productPlan.editTitle');
            // console.log(row);
        },
        handleShow(index, row) {
            this.productplan = row;
            this.viewVisible = true;
        },
        handleAdd() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.productplan = {};
            this.isadd = true;
            let date = new Date();
            // this.productplan.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.productplan.createUserId = userinfo.loginId;
            this.productplan.modifyUserId = userinfo.loginId;
            // this.productplan.enabled = true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.productPlan.addTitle');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.productPlan.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.productPlan.confirmDelete'), this.$t('pages.productPlan.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('productplan/productplanDel?ids=1')
                        .get('productplan/productplanDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.productPlan.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.productPlan.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.productPlan.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        },
        chgBalance(e) {
            let obj = [];
            this.balanceArr.map((item) => {
                //  this.unitList 是你 select option遍历的集合 e 是选中的id
                if (e.indexOf(item.id) > -1) {
                    obj.push(item.name);
                }
            });
            this.productplan.balanceNames = obj.join(',');
        },
        chgUser(e) {
            var realName = this.UserArr.filter((x) => x.id == e)[0].realName;
            console.log(realName);
            this.productplan.userName = realName;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
